
import { Component, Prop, Vue } from "vue-property-decorator";
import MatchInterface from "@/libs/model/MatchInterface";
import MatchInfo from "@/components/Match/MatchInfo.vue";

@Component({
   components: {
   MatchInfo
  },
})
export default class MatchHolder extends Vue
{
  name: 'MatchHolder';
  @Prop() matchdata: MatchInterface;
  @Prop() type: string;
  @Prop() index: number;
  @Prop() stage: string;
  @Prop() hidematchname: boolean;
   @Prop() stageindex: number;

   get matchHolderClass(): string {
    var cls  = ["match-holder"];
    if( this.stageindex === 0) {
       cls.push("first");
      cls.push("eighthFinal");
    }
    if( this.stageindex === 1) {
       cls.push("second");
       cls.push("quarterFinal")
    }
    if( this.stageindex === 2) {
       cls.push("third");
       cls.push("semiFinal")
    }
    if( this.stageindex === 3) {
      cls.push("fourth");
      if( this.index === 0) {
       cls.push("final")
       cls.push("winner")
      }
      if(this.index === 1)
       cls.push("thirdFinal") 
    }
    return cls.join(" ");
  }
 
 
}
